import LanguageList from 'components/LanguageList';

const LanguageChanger = ({children}) => (
    <div className="language-changer">
        <LanguageList>
            {children}
        </LanguageList>
    </div>
);

export default LanguageChanger;
